export default "__VITE_ASSET__DGRM2Rbk__"